import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IMenuItem } from '../../services/navigation.service';
import { CookieService } from 'ngx-cookie-service';
import { Router } from '@angular/router';
import { SettingsService } from 'src/app/views/settings/settings.service';

@Component({
  selector: 'app-sidenav',
  templateUrl: './sidenav.component.html'
})
export class SidenavComponent {
  @Input('items') public menuItems: IMenuItem[] = [];
  @Input('hasIconMenu')
  public hasIconTypeMenuItem!: boolean;
  @Input('iconMenuTitle') public iconTypeMenuTitle!: string;
  @Output() menuClick: EventEmitter<any> = new EventEmitter<any>();
  isWarningNotification: boolean = false;
  isForceNotification: boolean = false;
  mailCount!:any[];
  private readonly menuOrder = [
    'dashboard',
    'search',
    'inbox',
    'operations',
    'user management',
    'data management',
    'help',
    'notifications',
    'settings',
    'my profile',
    'contact us',
    'sign out'
  ];
  private readonly buyerHelpUrl = 'https://vsmps-assets-dev.s3.eu-west-1.amazonaws.com/VSMPS_Buyer_Manual+_V1.0.0.1.pdf';
  private readonly supplierHelpUrl = 'https://vsmps-assets-dev.s3.eu-west-1.amazonaws.com/VSMPS_Supplier+_Manual_V1.0.0.1.pdf';
  private readonly adminHelpUrl = 'https://vsmps-assets-dev.s3.eu-west-1.amazonaws.com/VSMPS_Admin_Manual_V1.0.0.1.pdf';
  private userRole = '';

  constructor(private cookieService: CookieService,private router: Router, private settingsService: SettingsService,) {
    this.isWarningNotification = this.cookieService.check("isWarningNotification") ? JSON.parse(this.cookieService.get("isWarningNotification")) : false;
    this.isForceNotification = this.cookieService.check("isForceNotification") ? JSON.parse(this.cookieService.get("isForceNotification")) : false;
    this.userRole = (this.cookieService.get('userRole') || '').trim().toLowerCase();
    this.addMenuItem();
  }
  
  // Only for demo purpose
  async addMenuItem() {
    this.menuItems.push({
      name: 'ITEM',
      type: 'dropDown',
      tooltip: 'Item',
      icon: 'done',
      state: 'material',
      sub: [
        { name: 'SUBITEM', state: 'cards' },
        { name: 'SUBITEM', state: 'buttons' }
      ],
      action: null
    });

    this.mailCount = await this.settingsService.getUnreadMailCountByUserId()
    console.log(this.mailCount,'this.mailCount')
  }

  onMenuClick(menu:IMenuItem){
    this.menuClick.emit(menu)
    if (menu.sub) {
      this.router.navigate([`/${menu.state}`]);
    } else {
      this.router.navigate([`/${menu.state}`]);
    }
  }

  handleMenuClick(menu: IMenuItem, event: Event) {
    const isHelpMenu = (menu?.name || '').trim().toLowerCase() === 'help';
    if (!isHelpMenu) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();

    const pdfUrl = this.userRole === 'owner' ? this.buyerHelpUrl : this.userRole === 'admin' ? this.adminHelpUrl : this.supplierHelpUrl;
    window.open(`${pdfUrl}#toolbar=1`, '_blank');
  }

  get orderedMenuItems(): IMenuItem[] {
    const normalizeName = (name?: string) => (name || '').split('(')[0].trim().toLowerCase();
    const itemsWithIndex = this.menuItems.map((item, index) => ({ item, index }));
    itemsWithIndex.sort((a, b) => {
      const aName = normalizeName(a.item.name);
      const bName = normalizeName(b.item.name);
      const aOrder = this.menuOrder.indexOf(aName);
      const bOrder = this.menuOrder.indexOf(bName);
      const aRank = aOrder === -1 ? this.menuOrder.length + a.index : aOrder;
      const bRank = bOrder === -1 ? this.menuOrder.length + b.index : bOrder;
      return aRank - bRank;
    });
    return itemsWithIndex.map(entry => entry.item);
  }
}
